import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import {updateObject} from 'helpers/ReducerUtil'

import VoltageConfig from './VoltageConfig'
import ListFilter from 'components/custom/ListFilter/index'
import AddPopupDialog from 'components/custom/AddPopupDialog/index'
import AddPopup from 'components/custom/AddPopup/index'

import { TableCell } from 'react-toolbox/lib/table'

import styles from './styles.scss'

class VoltageRegulator extends Component {
  constructor(props) {
    super(props)

    this.filterStatus = {
      vendorName: props.vendorNameFilter,
      partNumber: props.partNumberFilter,
      partType: props.partTypeFilter,
      phaseCount: props.phaseCountFilter,
      efficiency: props.efficiencyFilter
    }

    this.defaultKeys = ['partNumber', 'partType']
  }

  componentDidMount() {
    this.props.initFilters(this.filterStatus)
    this.props.onResetFilter(this.defaultKeys)
  }

  render() {
    const {
      values,
      sources,
      powerComponents,
      powerComponentsTypes,
      formElements,
      togglePopup,
      configSelection,
      configSource,
      curConfig,
      filterPairs,
      edpPeak,
      edpContinuous,
      outputVoltage,
      onTogglePopup,
      onVendorNameChange,
      onPartNumberChange,
      onPartTypeChange,
      onPhaseCountChange,
      onEfficiencyChange,
      onUpdateConfig,
      onUpdateConfigSource,
      onAddPart,
      onDeletePart,
      onEditPart,
      setEditPart,
      isEdit,
      setIsAddPart,
      isAddPart,
      onUpdatePhaseCount,
      onUpdateEfficiency,
      onUpdateEdpPeak,
      onUpdateEdpContinuous,
      onUpdateOutputVoltage,
      onUpdateCurConfig,
      onRefreshFilter,
      onSelectFilter,
      onDeleteFilter,
      onResetFilter,
      initFilters,
      vendorNameFilter,
      partNumberFilter,
      partTypeFilter,
      phaseCountFilter,
      efficiencyFilter,
      selectedFilter,
      onAddComponent,
      onUpdateComponent,
      onRemoveComponent,
    } = this.props

    const filterHandlers = {
      vendorName: this.props.onVendorNameChange,
      partNumber: this.props.onPartNumberChange,
      partType: this.props.onPartTypeChange,
      phaseCount: this.props.onPhaseCountChange,
      efficiency: this.props.onEfficiencyChange
    }

    this.filterStatus = {
      vendorName: this.props.vendorNameFilter,
      partNumber: this.props.partNumberFilter,
      partType: this.props.partTypeFilter,
      phaseCount: this.props.phaseCountFilter,
      efficiency: this.props.efficiencyFilter,
    }

    const voltageConfigSource = this.props.configSource.map(config => {
      return updateObject(config, {railType: this.props.curConfig.railType})
    })

    // const configModel = {
    //   vendorName: {header: <div></div>, title: 'Vendor Name'},
    //   partType: {header: <div></div>, title: 'Part Type'},
    //   partNumber: {header: <div></div>, title: 'Part Number'},
    //   phaseCount: {header: <div></div>, title: 'Phase Count'},
    // }

    const tableHeadContent = {
        vendorName: (<TableCell key={0}>Vendor Name</TableCell>),
        partType: (<TableCell key={1}>Part Type</TableCell>),
        partNumber: (<TableCell key={2}>Part Number</TableCell>),
        phaseCount: (<TableCell key={3}>Phase Count</TableCell>),
    }

    const refreshFilter = () => {
      onRefreshFilter()
      onResetFilter(this.defaultKeys)
    }

    // render power components only if corresponding form element exists
    const showPowerComponents = Object.values(formElements).filter(element => element.key === 'power_components').length > 0
    
    return (
      <Flex styleName="VoltageWrapper">
        {showPowerComponents && <p class={styles.heading}>Power Supply</p>}
        <VoltageConfig
          sources={sources}
          powerComponents={powerComponents}
          powerComponentsTypes={powerComponentsTypes}
          showPowerComponents={showPowerComponents}
          values={values}
          filterStatus={this.filterStatus}
          togglePopup={togglePopup}
          edpPeak={edpPeak}
          edpContinuous={edpContinuous}
          outputVoltage={outputVoltage}
          initFilters={initFilters}
          onTogglePopup={onTogglePopup}
          onDeletePart={onDeletePart}
          onUpdatePhaseCount={onUpdatePhaseCount}
          onUpdateEfficiency={onUpdateEfficiency}
          onUpdateEdpPeak={onUpdateEdpPeak}
          onUpdateEdpContinuous={onUpdateEdpContinuous}
          onUpdateOutputVoltage={onUpdateOutputVoltage}
          onUpdateCurConfig={onUpdateCurConfig}
          onAddComponent={onAddComponent}
          onUpdateComponent={onUpdateComponent}
          onRemoveComponent={onRemoveComponent}
          setEditPart={setEditPart}
          isEdit={isEdit}
          setIsAddPart={setIsAddPart}
          isAddPart={isAddPart}
        />
        <AddPopupDialog
          togglePopup={togglePopup}
          tabTitles={[curConfig.railType]}
          onTogglePopup={onTogglePopup}
          onUpdateConfig={onUpdateConfig}
          onUpdateConfigSource={onUpdateConfigSource}
          onRefreshFilter={refreshFilter}
        >
          <AddPopup
            isEdit={isEdit}
            setEditPart={setEditPart}
            sources={sources}
            configSelection={configSelection}
            configSource={voltageConfigSource}
            curConfig={curConfig}
            onTogglePopup={onTogglePopup}
            onAddPart={onAddPart}
            onEditPart={onEditPart}
            filterStatus={this.filterStatus}
            onUpdateConfig={onUpdateConfig}
            onUpdateConfigSource={onUpdateConfigSource}
            tableHeadContent={tableHeadContent}
            onRefreshFilter={refreshFilter}
          >
            <ListFilter
              sources={sources}
              curConfig={curConfig}
              filterPairs={filterPairs}
              filterHandlers={filterHandlers}
              filterStatus={this.filterStatus}
              onUpdateConfig={onUpdateConfig}
              onUpdateConfigSource={onUpdateConfigSource}
              onRefreshFilter={onRefreshFilter}
              onSelectFilter={onSelectFilter}
              onDeleteFilter={onDeleteFilter}
              selectedFilter={selectedFilter}
              deletable={false}
            />
          </AddPopup>
        </AddPopupDialog>
      </Flex>
    )
  }
}

export default CSSModules(VoltageRegulator, styles)
